var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "parametric-card",
        { "is-booked": _vm.flat.isBooked, "is-hovered": _vm.cardHovered }
      ],
      on: {
        click: function($event) {
          return _vm.redirectLeft(_vm.flat.link, _vm.flat.id)
        },
        mouseenter: _vm.hoverCard,
        mouseleave: function($event) {
          _vm.cardHovered = false
        }
      }
    },
    [
      _c("div", { staticClass: "parametric-card__content" }, [
        _c("div", { staticClass: "parametric-card__top" }, [
          _c(
            "p",
            { staticClass: "parametric-card__area parametric-results__loader" },
            [
              _vm._v("\n                " + _vm._s(_vm.flat.area) + " м"),
              _c("sup", [_vm._v("2")])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "parametric-card__title parametric-results__loader"
            },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.flat.title) + "\n            "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "parametric-card__params" }, [
          _vm.flat.deadlineText
            ? _c(
                "p",
                {
                  staticClass:
                    "parametric-card__params-param parametric-results__loader"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.flat.deadlineText) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEstateFlat && _vm.flat.floor
            ? _c(
                "p",
                {
                  staticClass:
                    "parametric-card__params-param parametric-results__loader"
                },
                [
                  _vm._v(
                    "\n                Этаж " +
                      _vm._s(_vm.flat.floor) +
                      " из " +
                      _vm._s(_vm.flat.floorsTotal) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              class: [
                "parametric-results__favorite",
                "j-favorite-btn",
                { "is-active": _vm.checkFavorite(_vm.flat.id) }
              ],
              attrs: { type: "button", "data-id": _vm.flat.id }
            },
            [_c("FavoriteIcon")],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "parametric-card__plan" },
          [
            _c("img", { attrs: { src: _vm.flat.plan, alt: _vm.flat.title } }),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade-default" } }, [
              _vm.isMobile || (_vm.cardHovered && _vm.flat.plan)
                ? _c(
                    "button",
                    {
                      ref: "zoom",
                      staticClass: "button parametric-card__plan-zoom j-zoom",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.zoom($event)
                        }
                      }
                    },
                    [_c("ZoomIcon")],
                    1
                  )
                : _vm._e()
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "parametric-card__price" }, [
          _vm.flat.isBooked
            ? _c(
                "div",
                {
                  staticClass:
                    "parametric-card__state parametric-results__loader"
                },
                [_vm._v("Забронировано")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.flat.isBooked
            ? _c("div", { staticClass: "parametric-card__prices" }, [
                _c("div", { staticClass: "parametric-results__loader" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        Number(_vm.flat.price)
                          ? _vm.convertToDigit(_vm.flat.price) + " ₽"
                          : _vm.flat.price
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.flat.priceOld
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "parametric-card__price-old parametric-results__loader"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              Number(_vm.flat.priceOld)
                                ? _vm.convertToDigit(_vm.flat.priceOld) + " ₽"
                                : _vm.flat.priceOld
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.flat.options && _vm.flat.options.length
            ? _c(
                "div",
                {
                  staticClass:
                    "parametric-card__options j-parametric-card-options"
                },
                [
                  _c("div", { staticClass: "parametric-card__options-item" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.flat.options[0].name) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "parametric-card__options-more\n                    j-parametric-card-options-more",
                      on: {
                        click: _vm.clickOnMobile,
                        mouseenter: function($event) {
                          return _vm.showTooltip()
                        },
                        mouseleave: _vm.hideTooltip
                      }
                    },
                    [_c("MoreIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _vm.flat.options.length > 1
                        ? _c("OptionsList", {
                            attrs: {
                              options: _vm.flat.options.slice(
                                1,
                                _vm.flat.options.length
                              ),
                              isOpen: _vm.optionsIsOpen
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.flat.isBooked
        ? _c(
            "div",
            { staticClass: "parametric-card__booked" },
            [_c("BookedIcon")],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }